var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRenotifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0445 10.7441C16.813 12.919 15.5807 14.9571 13.5416 16.1344C10.1536 18.0904 5.82155 16.9297 3.86554 13.5417L3.6572 13.1809M2.9553 9.25602C3.1868 7.08111 4.41913 5.043 6.45828 3.8657C9.84619 1.90969 14.1783 3.07047 16.1343 6.45838L16.3426 6.81922M2.91113 15.055L3.52118 12.7783L5.79788 13.3884M14.202 6.61173L16.4787 7.22177L17.0888 4.94506M9.99995 6.25004V10L12.0833 11.25",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenotifyIcon);
export default __webpack_public_path__ + "static/media/renotify-icon.fac9a9270921d93a9f5c3ea518ca5c70.svg";
export { ForwardRef as ReactComponent };